import { render, staticRenderFns } from "./task-rate.vue?vue&type=template&id=0fe83462&scoped=true&"
import script from "./task-rate.vue?vue&type=script&lang=js&"
export * from "./task-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe83462",
  null
  
)

export default component.exports